/**
 * 드롭다운 검색 대조.
 *
 * `포스코→한라시멘트` 를 **`포스코한`** 으로도 찾게 한다. 예전에는 라벨에 그대로 `includes`
 * 를 걸어서, 가운데 화살표 때문에 상차지와 하차지를 이어 칠 수 없었다 — 구간이 697개인
 * 화면에서 이건 사실상 검색이 안 되는 것과 같았다(UI 개선 요청 2026-08-26).
 *
 * 두 가지를 한다.
 *
 * 1. **이어 붙임을 방해하는 글자를 지우고 비교한다.** 화살표·공백·`_`·괄호·하이픈 따위다.
 *    `아세아시멘트_제천` 과 `아세아시멘트(제천)` 이 같은 검색어에 걸리는 부수 효과도 있다 —
 *    같은 곳을 자료마다 다르게 적어 두는 이 프로젝트에서는 그게 맞다.
 * 2. **띄어 쓴 낱말은 전부 맞아야 한다.** `단양 성신` 으로도 `성신양회(단양)` 을 찾는다.
 *    순서를 외우지 않아도 되게 하려는 것이다.
 *
 * 낱말은 라벨과 보조 설명 중 **어느 한쪽에만** 있어도 맞는 것으로 본다. 둘을 한 덩어리로
 * 이어 붙이면 `한라시멘트` + `미사용` 이 `시멘트미` 같은 검색어에 걸려 버린다.
 */

/** 이어 붙임을 방해하는 글자 — 지우고 비교한다 */
const NOISE = /[\s→\-_()[\]{}·,./]/g;

function squash(value: string): string {
  return value.toLowerCase().replace(NOISE, "");
}

/** 검색어를 낱말로 쪼갠다. 빈 검색어는 빈 배열 — 그때는 전부 맞는 것으로 본다 */
export function searchTerms(query: string): string[] {
  return query.trim().split(/\s+/).map(squash).filter(Boolean);
}

/** 미리 쪼갠 낱말로 대조한다. 목록을 훑을 때 낱말 쪼개기를 매 항목 반복하지 않으려는 것 */
export function matchesTerms(
  terms: readonly string[],
  ...fields: (string | null | undefined)[]
): boolean {
  if (terms.length === 0) return true;
  const hay = fields.filter(Boolean).map((f) => squash(f as string));
  return terms.every((term) => hay.some((field) => field.includes(term)));
}

/** 한 건만 대조할 때 쓰는 간편형 */
export function matchesSearch(
  query: string,
  ...fields: (string | null | undefined)[]
): boolean {
  return matchesTerms(searchTerms(query), ...fields);
}
